module.exports = __webpack_public_path__ + "img/close-eye.2dfb44f6.svg";